<div fxLayout="row">
  <div fxFlex="93">
    <h2>{{ selectedDocument?.WorkerFullName }}</h2>
  </div>
  <div fxFlex="7">
    <button mat-icon-button color="primary" (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<div class="subtitle">
  <span>{{ 'Legalization.LegalizationDocuments' | translate }}</span>
  <mat-divider></mat-divider>
</div>

<div fxLayout="column" fxLayoutGap="10px">
  <form [formGroup]="formGroup">
    <app-legalization-file-type-selector
      [disabled]="this.isFormReadonly()"
      [selectedTypeId]="selectedDocument?.LegalizationDocumentTypeId"
      (typeSelected)="onLegalizationTypeSelected($event)"
      >
    </app-legalization-file-type-selector>

    @if (description.value) {
      <mat-form-field appearance="outline" fxFill class="readonly-field">
        <mat-label>{{ 'Legalization.DocumentDescription' | translate }}</mat-label>
        <textarea
          matInput
          cdkTextareaAutosize
          #autosize="cdkTextareaAutosize"
          formControlName="description"
          cdkAutosizeMinRows="1"
          cdkAutosizeMaxRows="5"
          readonly
        ></textarea>
      </mat-form-field>
    }

    <div fxLayout="row" fxLayoutGap="10px">
      <mat-form-field fxFlex="50" appearance="outline">
        <mat-label>{{ 'Legalization.StartDate' | translate }}</mat-label>
        <input
          matInput
          [matDatepicker]="startDatePicker"
          formControlName="startDate"
          autocomplete="date"
          [matDatepickerFilter]="documentStartDateFilter"
          />
          <mat-datepicker-toggle [for]="startDatePicker" matSuffix></mat-datepicker-toggle>
          <mat-datepicker #startDatePicker startView="multi-year"></mat-datepicker>
          @if (!startDate || (startDate.invalid && startDate.touched)) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field fxFlex="50" appearance="outline">
          <mat-label>{{ 'Legalization.EndDate' | translate }}</mat-label>
          <input matInput [matDatepicker]="endDatePicker" formControlName="endDate" autocomplete="date" [matDatepickerFilter]="documentEndDateFilter" />
          <mat-datepicker-toggle [for]="endDatePicker" matSuffix></mat-datepicker-toggle>
          <mat-datepicker #endDatePicker startView="multi-year"></mat-datepicker>
          @if (!endDate || (endDate.invalid && endDate.touched)) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutGap="10px">
        <mat-form-field fxFlex="50" appearance="outline">
          <mat-label>{{ 'Legalization.DocumentNumber' | translate }}</mat-label>
          <input matInput type="text" formControlName="documentNumber" />
          @if (documentNumber.invalid && documentNumber.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field fxFlex="50" appearance="outline">
          <mat-label>{{ 'Legalization.SubmissionDate' | translate }}</mat-label>
          <input matInput [matDatepicker]="submissionDatePicker" formControlName="submissionDate" autocomplete="date" />
          <mat-datepicker-toggle [for]="submissionDatePicker" matSuffix></mat-datepicker-toggle>
          <mat-datepicker #submissionDatePicker startView="multi-year"></mat-datepicker>
          @if (submissionDate.invalid && submissionDate.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>

      <mat-form-field appearance="outline" fxFill>
        <mat-label>{{ 'Legalization.Comment' | translate }}</mat-label>
        <textarea
          matInput
          [maxLength]="300"
          cdkTextareaAutosize
          #autosize="cdkTextareaAutosize"
          formControlName="comment"
          cdkAutosizeMinRows="1"
          cdkAutosizeMaxRows="5"
        ></textarea>
        @if (comment.invalid && comment.touched) {
          <mat-error>
            {{ 'InvalidField' | translate }}
          </mat-error>
        }
      </mat-form-field>
      <div>
        <mat-radio-group formControlName="documentCategory" required>
          <mat-radio-button [value]="1">{{ 'Legalization.StayLegalization' | translate }}</mat-radio-button>
          <mat-radio-button [value]="2">{{ 'Legalization.WorkLegalization' | translate }}</mat-radio-button>
          <mat-radio-button [value]="3">{{ 'Legalization.StayAndWorkLegalization' | translate }}</mat-radio-button>
        </mat-radio-group>
      </div>

      <div fxLayout="row" fxLayoutGap="10px" [style.margin-top.px]="12">
        <mat-form-field fxFlex="50" appearance="outline" fxFill>
          <mat-label>{{ 'Legalization.DocumentStatus' | translate }}</mat-label>
          <mat-select formControlName="documentStatus">
            @for (status of listOfLegalizationDocumentStatuses$ | async; track status) {
              <mat-option [value]="status.Id">
                {{ status.Name }}
              </mat-option>
            }
          </mat-select>
          @if (status.invalid && status.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field fxFlex="50" appearance="outline" fxFill>
          <mat-label>{{ 'Legalization.LegalizationStatus' | translate }}</mat-label>
          <mat-select formControlName="status">
            @for (status of listOfLegalizationStatuses$ | async; track status) {
              <mat-option [value]="status.Id">
                {{ status.Name }}
              </mat-option>
            }
          </mat-select>
          @if (status.invalid && status.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutGap="10px" [style.margin-top.px]="12">
        <mat-form-field fxFlex="50" appearance="outline" fxFill>
          <mat-label>{{ 'Legalization.ActiveAlert' | translate }}</mat-label>
          <mat-select formControlName="alertStatusId">
            @for (status of listOfLegalizationAlertStatusesForForms$ | async; track status) {
              <mat-option [value]="status.Id">
                {{ status.Name }}
              </mat-option>
            }
          </mat-select>
          @if (status.invalid && status.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>

      <div class="active-files-section">
        <mat-divider></mat-divider>
        @for (file of selectedDocument?.Files; track file; let i = $index) {
          <div class="file">
            <span class="index">{{ i + 1 }}.</span>
            <a href="javascript:void(0)" (click)="showFile(file)">{{ file.Name ?? file.OriginalName }}</a>
            <button mat-icon-button color="primary" (click)="downloadFile(file.Id, file.Name)">
              <mat-icon>download</mat-icon>
            </button>
          </div>
        }
        <mat-divider></mat-divider>
      </div>
    </form>

    <div class="header-wrapper"></div>

    <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px" class="buttons-wrapper">
      <button mat-raised-button (click)="onClose()">
        {{ 'Cancel' | translate }}
      </button>
      @if (saveButtonsVisible()) {
        <button mat-raised-button color="primary" (click)="onSaveBtnClick()" [disabled]="!isSaveBtnEnabled()">
          {{ 'Save' | translate }}
        </button>
      }
      @if (saveButtonsVisible()) {
        <button mat-raised-button color="primary" (click)="onSaveAndAttachBtnClick()" [disabled]="!isSaveAndAttachBtnEnabled()">
          {{ 'Legalization.SaveAndAttach' | translate }}
        </button>
      }
    </div>
  </div>
